import React from "react";
var __jsx = React.createElement;
import ContentPanelBox from "@/pages/car-comparison/components/ContentPanelBox";
import { twMerge } from "tailwind-merge";
var ContentItem = function ContentItem(_ref) {
  var rightNode = _ref.rightNode,
    leftNode = _ref.leftNode,
    itemTitle = _ref.itemTitle,
    _ref$titleInside = _ref.titleInside,
    titleInside = _ref$titleInside === void 0 ? false : _ref$titleInside,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$titleClassName = _ref.titleClassName,
    titleClassName = _ref$titleClassName === void 0 ? '' : _ref$titleClassName,
    _ref$hasTitle = _ref.hasTitle,
    hasTitle = _ref$hasTitle === void 0 ? true : _ref$hasTitle,
    _ref$centerTitleDeskt = _ref.centerTitleDesktop,
    centerTitleDesktop = _ref$centerTitleDeskt === void 0 ? false : _ref$centerTitleDeskt,
    id = _ref.id,
    titleId = _ref.titleId,
    rightId = _ref.rightId,
    leftId = _ref.leftId;
  var renderContentSeparator = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ContentPanelBox, null, /*#__PURE__*/React.createElement(ContentPanel, {
    itemTitle: itemTitle,
    rightNode: rightNode,
    leftNode: leftNode,
    titleInside: titleInside,
    hasTitle: hasTitle,
    rightId: rightId,
    leftId: leftId,
    titleId: titleId
  })));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: twMerge("flex flex-col gap-2", className)
  }, /*#__PURE__*/React.createElement("p", {
    id: titleId && !titleInside ? titleId : undefined,
    className: twMerge("text-sm text-neutral-90 font-bold", titleInside ? 'md:hidden' : '', titleClassName, centerTitleDesktop ? "md:text-center" : "")
  }, itemTitle), renderContentSeparator));
};
var ContentPanel = function ContentPanel(_ref2) {
  var rightNode = _ref2.rightNode,
    leftNode = _ref2.leftNode,
    titleInside = _ref2.titleInside,
    itemTitle = _ref2.itemTitle,
    _ref2$hasTitle = _ref2.hasTitle,
    hasTitle = _ref2$hasTitle === void 0 ? true : _ref2$hasTitle,
    _ref2$backgroundColor = _ref2.backgroundColor,
    backgroundColor = _ref2$backgroundColor === void 0 ? 'transparent' : _ref2$backgroundColor,
    _ref2$hasSeparator = _ref2.hasSeparator,
    hasSeparator = _ref2$hasSeparator === void 0 ? true : _ref2$hasSeparator,
    id = _ref2.id,
    titleId = _ref2.titleId,
    rightId = _ref2.rightId,
    leftId = _ref2.leftId;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "w-full ".concat(backgroundColor, " flex")
  }, hasTitle && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    id: titleId,
    className: twMerge("md:shrink-0 md:flex-[20%] text-gray-text font-bold text-sm shrink-0", titleInside ? 'md:block hidden' : "")
  }, itemTitle)), /*#__PURE__*/React.createElement("div", {
    className: "w-full flex items-center justify-evenly ".concat(titleInside ? 'md:flex-[80%]' : '')
  }, /*#__PURE__*/React.createElement("p", {
    id: rightId,
    className: "text-xs text-primary font-bold w-1/2 justify-center flex "
  }, rightNode), hasSeparator && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "h-6 w-px bg-[#E1E8F2] rounded"
  })), /*#__PURE__*/React.createElement("p", {
    id: leftId,
    className: "text-xs text-primary font-bold w-1/2 justify-center flex "
  }, leftNode))));
};
ContentItem.Panel = ContentPanel;
export default ContentItem;